// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__2sjgO","footer":"ModalCreateQualiphyProcedure_footer__WJXhX","additionData":"ModalCreateQualiphyProcedure_additionData__1I41r"};